    <script type="text/ecmascript-6">
    import DesignerQuestionHardwareLock from "../DesignerQuestionHardwareLock.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareLock
        ],
        computed: {
            panel_required(){
                return false;
            },
        },
    }
</script>
